import { v4 as uuidv4 } from 'uuid';
import {
  disconnect,
  getEnrollmentId,
  readTransaction,
  registerDAppToken,
  writeTransaction,
  reEngagingEvents,
  getCurrentNetwork,
} from './connector';
import {
  CustomError,
  InternalServerError,
  ValidationError,
} from './utils/errors';
import { logError } from './utils/logger';
 
const handleError = (error, message) => {
  if (!(error instanceof CustomError)) {
    error = new InternalServerError(message);
  }
  logError(error);
  throw error;
};
 
const getToken = () => {
  try {
    return uuidv4();
  } catch (error) {
    handleError(error, 'Failed to generate the token');
    return undefined;
  }
};
 
const connectToWallet = async (
  token,
  name,
  dappURL,
  dappIcon,
  network,
  handleDisconnect
) => {
  try {
    if (!token) {
      token = getToken() || '';
    }
 
    if (!name) {
      console.error('ValidationError: Name is required');
      throw new ValidationError('Name is required');
    }
 
    const result = await registerDAppToken(
      token,
      name,
      dappURL,
      dappIcon,
      network,
      handleDisconnect
    );
 
    return result;
  } catch (error) {
    console.error('Error in connectToWallet:', error);
    handleError(error, 'Failed to connect to wallet');
    return false;
  }
};
 
const reEngageEvents = async (
  token,
  name,
  dappURL,
  dappIcon
) => {
  try {
    if (!token) token = getToken() || '';
    if (!name) throw new ValidationError('Name is required');
 
    return await reEngagingEvents(token, name, dappURL, dappIcon);
  } catch (error) {
    handleError(error, 'Failed to re-engage events');
    return false;
  }
};
 
const getEnrollmentIdFromWallet = async (
  token,
  name,
  dappURL,
  dappIcon
) => {
  try {
    if (!token) throw new ValidationError('DappToken is required');
    const res = await getEnrollmentId(token, name, dappURL, dappIcon);
    return res.enrollmentId;
  } catch (error) {
    handleError(error, 'Failed to retrieve enrollment ID');
    return undefined;
  }
};
 
const writeTransactionFromWallet = async (
  token,
  name,
  dappURL,
  dappIcon,
  channelName,
  chaincodeName,
  transactionName,
  transactionParams
) => {
  console.log("---->write",{token,
    name,
    dappURL,
    dappIcon,
    channelName,
    chaincodeName,
    transactionName,
    transactionParams});
  try {
    if (!token) throw new ValidationError('DappToken is required');
    return await writeTransaction(
      token,
      name,
      dappURL,
      dappIcon,
      channelName,
      chaincodeName,
      transactionName,
      transactionParams
    );
  } catch (error) {
    handleError(error, 'Failed to write transaction');
    return null;
  }
};
 
const readTransactionFromWallet = async (
  token,
  name,
  dappURL,
  dappIcon,
  channelName,
  chaincodeName,
  transactionName,
  transactionParams
) => {
  console.log("---->",{token,
  name,
  dappURL,
  dappIcon,
  channelName,
  chaincodeName,
  transactionName,
  transactionParams});
  try {
    if (!token) throw new ValidationError('DappToken is required');
    return await readTransaction(
      token,
      name,
      dappURL,
      dappIcon,
      channelName,
      chaincodeName,
      transactionName,
      transactionParams
    );
  } catch (error) {
    handleError(error, 'Failed to read transaction');
    return null;
  }
};
 
const disconnectWallet = async (
  token,
  name,
  dappURL
) => {
  try {
    if (!token) throw new ValidationError('DappToken is required');
    return await disconnect(token, name, dappURL);
  } catch (error) {
    handleError(error, 'Failed to disconnect wallet');
    return null;
  }
};
 
const getCurrentWalletNetwork = async (
  token,
  name,
  dappURL
) => {
  return await getCurrentNetwork(token, name, dappURL);
};
 
export {
  getToken,
  connectToWallet,
  getEnrollmentIdFromWallet,
  writeTransactionFromWallet,
  readTransactionFromWallet,
  disconnectWallet,
  reEngageEvents,
  getCurrentWalletNetwork,
};